var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('section',{staticClass:"qualities"},[_c('h2',{staticClass:"demographics-section-title"},[_vm._v("Kvaliteter")]),_c('div',{staticClass:"qualities__charts"},_vm._l((_vm.value),function(item,index){return _c('Doughnut',{key:index,attrs:{"data":[
        Math.floor(parseFloat(item.score.value * 100)),
        Math.floor(100 - parseFloat(item.score.value * 100)),
      ],"title":item.name,"subtitle":item.score.text}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }